<!-- Notification icons -->
<ul class="ha__notifs">
  <li class="ha__notif hn--global">
    <a class="ha__notif__icn" [href]="yummypetsUrl + 'pet/notifications/pet'">
      <span class="icon i--notification i--gray-dark"></span>
      @if(countNotifications()) {
        <i class="notif__count--sup ncs--dark">{{ countNotifications() }}</i>
      }
    </a>
  </li>
  @if(currentPet()) {
    <li class="ha__notif hn--global">
      <a class="ha__notif__icn" [href]="yummypetsUrl + 'pet/messaging'">
        <span class="icon i--message i--gray-dark"></span>
        @if(countMessages()) {
          <i class="notif__count--sup ncs--dark">{{ countMessages() }}</i>
        }
      </a>
    </li>
  }
</ul>

<!-- Avatar -->
<a class="ha__avatar__wrapper"
   [routerLink]="isDesktop() ? '/board/edit-user' : null"
   (click)="onAvatarClick()">
  <ng-content></ng-content>
</a>
